// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ShoppingBagLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M15.17 3a3 3 0 012.12.88l2.83 2.83A3 3 0 0121 8.83V18a3 3 0 01-3 3H6a3 3 0 01-3-3V8.83a3 3 0 01.88-2.12l2.83-2.83A3 3 0 018.83 3zM19 9H5v9l.007.117A1 1 0 006 19h12a1 1 0 001-1V9zm-4 2l.117.007A1 1 0 0116 12l-.005.2A4 4 0 018 12l.007-.117A1 1 0 0110 12l.005.15A2 2 0 0014 12l.007-.117A1 1 0 0115 11zm.17-6H8.83a1.05 1.05 0 00-.71.29L6.41 7h11.18l-1.71-1.71a1.05 1.05 0 00-.71-.29z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const ShoppingBagLineOffset: IconOffset = {
    vertical: 10,
    horizontal: 10,
};

export default React.memo(ShoppingBagLine);
